/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import $ from "jquery";
import { Link } from "react-router-dom";
import OwlCarousel from "react-owl-carousel-autoheight";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const PropertyGallery = ({ img, id, isRedirect, setActiveModalId, address, index }) => {
  const [onLoad, setOnLoad] = useState(false);

  return (
    <Link
      data-bs-toggle={!isRedirect ? "modal" : ""}
      data-bs-target={!isRedirect ? "#propertyDetailQuickView" : ""}
      target={isRedirect ? "_blank" : "_self"}
      className="property-img"
      to={isRedirect && `/property-details/${id}`}
      onClick={() => {
        setActiveModalId({ id, address });
      }}
    >
      {index === 4 && (
        <div className="info-msg">
          <p>Want to see more photos and details?</p>
          <h6>Open Property Details</h6>
        </div>
      )}
      <figure className={onLoad ? "" : "skeleton-loading"}>
        <img
          src={img}
          loading="lazy"
          onLoad={() => {
            setOnLoad(true);
          }}
          alt=""
        />
      </figure>
    </Link>
  );
};

const PropertyItem = ({ eachProperty, handleActiveMarker, isRedirect = true, setActiveModalId = () => {} }) => {
  const { property, images } = eachProperty;
  const { listingID, address, bedrooms, totalBaths, sqFt, price_formatted } = property;

  useEffect(() => {
    $(".property-item .location").matchHeight({ property: "height" });
  }, []);

  const onShowProperty = () => {
    if (handleActiveMarker) {
      handleActiveMarker(listingID);
    }
  };

  const onHideProperty = () => {
    if (handleActiveMarker) {
      handleActiveMarker(null);
    }
  };

  return (
    <li onMouseMove={onShowProperty} onMouseLeave={onHideProperty} className="property-item">
      <button type="button" className="my-list-btn fa fa-heart"></button>
      <div className="gallery-slider">
        <OwlCarousel className="owl-carousel property-item-slider" nav={true} dots={true} margin={10} lazyLoad={true} items={1}>
          {images.map((eachImg, index) => (
            <PropertyGallery address={address} isRedirect={isRedirect} key={index} img={eachImg.full} id={listingID} setActiveModalId={setActiveModalId} index={index} />
          ))}
        </OwlCarousel>
      </div>
      <p className="location">
        <img src="../assets/images/location-img.png" alt="" /> {address}
      </p>
      <h6>Listing ID: {listingID}</h6>

      <div className="property-item-bottom">
        <ul>
          <li>
            <i className="fa fa-bed" aria-hidden="true"></i> {bedrooms}
          </li>
          <li>
            <i className="fa fa-shower" aria-hidden="true"></i> {totalBaths}
          </li>
          <li>
            <i className="fa fa-crop" aria-hidden="true"></i> {sqFt} Sqft
          </li>
        </ul>
        <strong>{price_formatted}</strong>
      </div>
    </li>
  );
};

export default PropertyItem;
